exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Nav-container{padding:0}.Nav-container .Nav-item{display:inline-block;text-transform:uppercase;padding:10px 0;width:50%;transition:background-color .5s ease}.Nav-container .Nav-item:hover{background-color:#f5f5f5}.Nav-container .Nav-item>a,.Nav-container:active,.Nav-container:visited{text-decoration:none;font-size:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Nav/Menu.scss
// module id = 328
// module chunks = 0